import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#bebebe" fill="#474747"><path d="M5 1v5h2v2H2.031v3H0v4.938h5V11H3.031V9H12v.984h1V8H8V6h2V1z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} overflow="visible" opacity={0.35} /><path d="M11 11h1.375l1.125 1.094L14.594 11H16v1.469l-1.094 1.062L16 14.594V16h-1.438L13.5 14.937 12.437 16H11v-1.406l1.063-1.063L11 12.47z" style={{
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;